export const ADMINISTRATOR = "ADMINISTRATOR";
export const CREDIT = "CREDIT";
export const ORDEM_COMPRA = "ORDEM_COMPRA";
export const PERMISSIONS = "PERMISSIONS";
